import { useState, useEffect, useRef } from 'react';
import NavBar from './NavBar';

const Analysis = () => {
  const [input, setInput] = useState(""); // Input pengguna
  const [messages, setMessages] = useState([]); // Riwayat pesan
  const [tableData, setTableData] = useState([]); // Table data from JSON file
  const messageEndRef = useRef(null); // Reference to scroll to the bottom

  // Handle sending message
  const handleSendMessage = async () => {
    if (!input.trim()) return;
    // Tambahkan input pengguna ke riwayat pesan
    setMessages((prev) => [...prev, { sender: "user", text: input }]);
    try {
      // Simulate NL to SQL conversion (can be expanded)
      const sqlQuery = convertNLToSQL(input);
      
      // Set the table data based on the input
      setTableData(getDataFromQuery(sqlQuery));

      // Tambahkan hasil query ke riwayat pesan
      setMessages((prev) => [
        ...prev,
        { sender: "bot", isTable: true, tableData: getDataFromQuery(sqlQuery) },
      ]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: err.message || "Error processing your request." },
      ]);
    }
    setInput(""); // Reset input
  };

  // Fungsi simulasi NL ke SQL (di real app gunakan model NLP)
  const convertNLToSQL = (input) => {
    if (input.toLowerCase().includes("provinsi")) {
      return "SELECT provinsi_data FROM provinsi";
    } else if (input.toLowerCase().includes("kabupaten")) {
      return "SELECT kabupaten_data FROM kabupaten";
    } else {
      return "SELECT default_data FROM default";
    }
  };

  // Get table data from local JSON (this is an example, modify it to your actual JSON structure)
  const getDataFromQuery = (query) => {
    switch (query) {
      case "SELECT provinsi_data FROM provinsi":
        return require('./data/provinsi.json'); // Assuming data is stored in ./data/provinsi.json
      case "SELECT kabupaten_data FROM kabupaten":
        return require('./data/kabupaten.json'); // Assuming data is stored in ./data/kabupaten.json
      default:
        return require('./data/default.json'); // Default data
    }
  };

  // Scroll to bottom when new messages are added
  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]); // Trigger scroll when messages change

  return (
    <div style={styles.container}>
      <div>
        <NavBar />
      </div>
      <div style={styles.chatbox}>
        <div style={styles.messageContainer}>
          {messages.map((msg, index) => (
            <div
              key={index}
              style={{
                ...styles.message,
                ...(msg.sender === "user" ? styles.userMessage : styles.botMessage),
              }}
            >
              {/* Render pesan teks atau tabel */}
              {msg.isTable ? (
                <TableRenderer data={msg.tableData} />
              ) : (
                msg.text
              )}
            </div>
          ))}
          <div ref={messageEndRef} /> {/* Scroll to this div */}
        </div>
        <div style={styles.inputContainer}>
          <input
            style={styles.input}
            type="text"
            placeholder="Ask something..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          <button style={styles.button} onClick={handleSendMessage}>
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

// Komponen untuk merender tabel
const TableRenderer = ({ data }) => {
  if (!data || data.length === 0) {
    return <div>No data available</div>;
  }

  // Ambil header dari data
  const headers = Object.keys(data[0]);

  return (
    <table style={styles.table}>
      <thead>
        <tr>
          {headers.map((header) => (
            <th key={header} style={styles.th}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            {headers.map((header) => (
              <td key={header} style={styles.td}>
                {row[header]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

// Styling untuk chatbot
const styles = {
  container: { display: "flex", justifyContent: "center", alignItems: "center" },
  chatbox: {
    width: "900px",
    height: "700px",
    border: "0px solid #ccc", // Frame border untuk chatbot
    borderRadius: "10px", 
    display: "flex",
    flexDirection: "column",
  },
  messageContainer: {
    flex: 1,
    padding: "10px",
    overflowY: "auto", // Enable vertical scrolling
    scrollBehavior: "smooth", // Smooth scrolling for better experience
  },
  message: {
    padding: "10px",
    borderRadius: "5px",
    margin: "5px 0",
    maxWidth: "80%",
    wordWrap: "break-word", // Ensure text does not overflow
  },
  userMessage: {
    backgroundColor: "#daf8e3",
    alignSelf: "flex-end",
  },
  botMessage: {
    //backgroundColor: "#f0f0f0",
    alignSelf: "flex-start",
  },
  inputContainer: {
    display: "flex",
    padding: "10px",
    borderTop: "1px solid #ccc",
  },
  input: {
    flex: 1,
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
  button: {
    padding: "10px",
    backgroundColor: "#9e8388",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    marginLeft: "10px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "1px",
  },
  th: {
    border: "0px solid #ccc",
    padding: "1px",
    fontfamily: "Helvetica",
  },
  td: {
    border: "0px solid #ccc",
    padding: "1px",
    fontfamily: "Helvetica",
  },
};

export default Analysis;
